"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.no_image = exports["default"] = void 0;
var catLandscape = {
  name: "natural",
  aspectRatio: 1.786,
  srcset: [{
    url: "/static/images/cat_420.png",
    w: 420,
    h: 236
  }, {
    url: "/static/images/cat_768.png",
    w: 768,
    h: 430
  }, {
    url: "/static/images/cat_1024.png",
    w: 1024,
    h: 534
  }, {
    url: "/static/images/cat_1280.png",
    w: 1280,
    h: 717
  }, {
    url: "/static/images/cat_1600.png",
    w: 1600,
    h: 896
  }, {
    url: "/static/images/cat_1920.png",
    w: 1920,
    h: 1075
  }]
};
var catPortrait = {
  name: "portrait",
  aspectRatio: 0.95611578,
  srcset: [{
    url: "/static/images/cat_p420.png",
    w: 420,
    h: 489
  }, {
    url: "/static/images/cat_p768.png",
    w: 768,
    h: 894
  }, {
    url: "/static/images/cat_p920.png",
    w: 1024,
    h: 1071
  }]
};
var bannerVertical = {
  name: "natural",
  aspectRatio: 0.8135,
  srcset: [{
    url: "/static/images/banner_vertical.jpg",
    w: 375,
    h: 461
  }]
};
var bannerSmall = {
  name: "natural",
  aspectRatio: 1.1719,
  srcset: [{
    url: "/static/images/banner_small.jpg",
    w: 375,
    h: 320
  }]
};
var bannerImageVertical = {
  id: 5678,
  altText: "Banner",
  originalSrc: "/static/images/banner_vertical.jpg",
  variants: [bannerVertical]
};
var bannerImageSmall = {
  id: 5678,
  altText: "Banner",
  originalSrc: "/static/images/banner_small.jpg",
  variants: [bannerSmall]
};
var catImage = {
  id: 1234,
  altText: "Sweet kitty",
  originalSrc: "/static/images/cat_1920.png",
  variants: [catLandscape, catPortrait]
};
var collectionTile1 = {
  altText: "Garden Essentials",
  originalSrc: "/static/images/collectiontile1.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/collectiontile1.png",
      w: 306,
      h: 382
    }]
  }]
};
var garnki = {
  name: "natural",
  aspectRatio: 1,
  srcset: [{
    url: "/static/images/productTypes/garnki.jpg",
    w: 107,
    h: 107
  }]
};
var collectionTile2 = {
  altText: "Wooden kitchen tools",
  originalSrc: "/static/images/collectiontile2.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/collectiontile2.png",
      w: 306,
      h: 382
    }]
  }]
};
var patelnieKwadratowe = {
  name: "natural",
  aspectRatio: 1,
  srcset: [{
    url: "/static/images/productTypes/patelnia_kwadratowa.jpg",
    w: 107,
    h: 107
  }]
};
var collectionTile3 = {
  altText: "Garden furniture",
  originalSrc: "/static/images/collectiontile3.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/collectiontile3.png",
      w: 306,
      h: 382
    }]
  }]
};
var patelnie = {
  name: "natural",
  aspectRatio: 1,
  srcset: [{
    url: "/static/images/productTypes/patelnia.jpg",
    w: 107,
    h: 107
  }]
};
var collectionTile4 = {
  altText: "Baking Essentials",
  originalSrc: "/static/images/collectiontile4.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/collectiontile4.png",
      w: 306,
      h: 382
    }]
  }]
};
var kuchenne = {
  name: "natural",
  aspectRatio: 1,
  srcset: [{
    url: "/static/images/productTypes/kuchenne.jpg",
    w: 107,
    h: 107
  }]
};
var garnkiImage = {
  id: 2222,
  altText: "Garnki",
  originalSrc: "/static/images/productTypes/garnek.jpg",
  variants: [garnki]
};
var patelnieKwadrawtoweImage = {
  id: 2222,
  altText: "Garnki",
  originalSrc: "/static/images/productTypes/patelnia_kwadratowa.jpg",
  variants: [patelnieKwadratowe]
};
var patelnieImage = {
  id: 2222,
  altText: "Garnki",
  originalSrc: "/static/images/productTypes/patelnia.jpg",
  variants: [patelnie]
};
var kuchenneImage = {
  id: 2222,
  altText: "Garnki",
  originalSrc: "/static/images/productTypes/kuchenne.jpg",
  variants: [kuchenne]
};
var instagram1 = {
  altText: "Instagram photo1",
  originalSrc: "/static/images/instagram1.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/instagram1.jpg",
      w: 188,
      h: 188
    }]
  }]
};
var instagram2 = {
  altText: "Instagram photo2",
  originalSrc: "/static/images/instagram2.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/instagram2.jpg",
      w: 188,
      h: 188
    }]
  }]
};
var instagram3 = {
  altText: "Instagram photo3",
  originalSrc: "/static/images/instagram3.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/instagram3.jpg",
      w: 188,
      h: 188
    }]
  }]
};
var pot = {
  altText: "Pot",
  originalSrc: "/static/images/products/pot.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/pot.png",
      w: 160,
      h: 160
    }]
  }]
};
var mixer = {
  altText: "Mixer",
  originalSrc: "/static/images/products/mixer.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/mixer.png",
      w: 160,
      h: 160
    }]
  }]
};
var knife = {
  altText: "Knife",
  originalSrc: "/static/images/products/knife.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/knife.png",
      w: 160,
      h: 160
    }]
  }]
};
var chair = {
  altText: "Chair",
  originalSrc: "/static/images/products/chair.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/chair.png",
      w: 160,
      h: 160
    }]
  }]
};
var collectionMain = {
  altText: "Collection main photo",
  originalSrc: "/static/images/collections/collection_card_main.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/collections/collection_card_main.jpg",
      w: 223,
      h: 223
    }]
  }]
};
var collection1 = {
  altText: "Collection thumb photo1",
  originalSrc: "/static/images/collections/collection_card_thumb_1.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/collections/collection_card_thumb_1.png",
      w: 111,
      h: 111
    }]
  }]
};
var collection2 = {
  altText: "Collection thumb photo2",
  originalSrc: "/static/images/collections/collection_card_thumb_2.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/collections/collection_card_thumb_2.png",
      w: 111,
      h: 111
    }]
  }]
};
var collectionPageMain1 = {
  altText: "Collection main photo",
  originalSrc: "/static/images/collections/collection-page-main1.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-main1.jpg",
      w: 652,
      h: 487
    }]
  }]
};
var collectionPageThumb1a = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb1-a.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb1-a.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageThumb1b = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb1-b.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb1-b.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageMain2 = {
  altText: "Collection main photo",
  originalSrc: "/static/images/collections/collection-page-main2.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-main2.jpg",
      w: 652,
      h: 487
    }]
  }]
};
var collectionPageThumb2a = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb2-a.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb2-a.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageThumb2b = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb2-b.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb2-b.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageMain3 = {
  altText: "Collection main photo",
  originalSrc: "/static/images/collections/collection-page-main3.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-main3.jpg",
      w: 652,
      h: 487
    }]
  }]
};
var collectionPageThumb3a = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb3-a.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb3-a.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageThumb3b = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb3-b.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb3-b.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageMain4 = {
  altText: "Collection main photo",
  originalSrc: "/static/images/collections/collection-page-main4.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-main4.jpg",
      w: 652,
      h: 487
    }]
  }]
};
var collectionPageThumb4a = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb4-a.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb4-a.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageThumb4b = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb4-b.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb4-b.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageMain5 = {
  altText: "Collection main photo",
  originalSrc: "/static/images/collections/collection-page-main5.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-main5.jpg",
      w: 652,
      h: 487
    }]
  }]
};
var collectionPageThumb5a = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb5-a.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb5-a.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageThumb5b = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb5-b.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb5-b.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageMain6 = {
  altText: "Collection main photo",
  originalSrc: "/static/images/collections/collection-page-main6.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-main6.jpg",
      w: 652,
      h: 487
    }]
  }]
};
var collectionPageThumb6a = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb6-a.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb6-a.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var collectionPageThumb6b = {
  altText: "Collection thumb photo",
  originalSrc: "/static/images/collections/collection-page-thumb6-b.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.3,
    srcset: [{
      url: "/static/images/collections/collection-page-thumb6-b.jpg",
      w: 244,
      h: 244
    }]
  }]
};
var inspirationMain = {
  altText: "Inspiration main photo",
  originalSrc: "/static/images/inspiration-main.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspiration-main.jpg",
      w: 500,
      h: 375
    }]
  }]
};
var inspirationMain2 = {
  altText: "Inspiration main photo",
  originalSrc: "/static/images/inspiration-main2.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspiration-main2.jpg",
      w: 500,
      h: 375
    }]
  }]
};
var inspirationMain3 = {
  altText: "Inspiration main photo",
  originalSrc: "/static/images/inspiration-main3.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspiration-main3.jpg",
      w: 500,
      h: 375
    }]
  }]
};
var inspirationMain4 = {
  altText: "Inspiration main photo",
  originalSrc: "/static/images/inspiration-main4.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspiration-main4.jpg",
      w: 500,
      h: 375
    }]
  }]
};
var inspirationMain5 = {
  altText: "Inspiration main photo",
  originalSrc: "/static/images/inspiration-main5.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspiration-main5.jpg",
      w: 500,
      h: 375
    }]
  }]
};
var inspirationMain6 = {
  altText: "Inspiration main photo",
  originalSrc: "/static/images/inspiration-main6.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspiration-main6.jpg",
      w: 500,
      h: 375
    }]
  }]
};
var inspirationThumb1 = {
  altText: "Inspiration thumb photo1",
  originalSrc: "/static/images/inspiration-thumb-1.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspiration-thumb-1.png",
      w: 111,
      h: 111
    }]
  }]
};
var inspirationThumb2 = {
  altText: "Inspiration thumb photo2",
  originalSrc: "/static/images/inspirtaion-thumb-2.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspirtaion-thumb-2.png",
      w: 111,
      h: 111
    }]
  }]
};
var inspirationThumb3 = {
  altText: "Inspiration thumb photo3",
  originalSrc: "/static/images/inspiration-thumb-3.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/inspiration-thumb-3.png",
      w: 111,
      h: 111
    }]
  }]
};
var influancerPhoto = {
  altText: "Instagram profile",
  originalSrc: "/static/images/instagram-profile.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/instagram-profile.jpg",
      w: 251,
      h: 251
    }]
  }]
};
var newsletterTopImage = {
  altText: "Newsletter to image",
  originalSrc: "/static/images/newsletter_top.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.5,
    srcset: [{
      url: "/static/images/newsletter_top.jpg",
      w: 378,
      h: 251
    }]
  }]
};
var verticalPhoto = {
  altText: "Vertical image from figma",
  originalSrc: "/static/images/vertical_photo_five_two_wooden.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 0.8135,
    srcset: [{
      url: "/static/images/vertical_photo_five_two_wooden.jpg",
      w: 160,
      h: 237
    }]
  }]
};
var glasses = [{
  altText: "Szklanka do whisky Experience 325 ml STOLZLE",
  originalSrc: "/static/images/products/glasses/1/293695x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/glasses/1/293695x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/glasses/1/293695x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/glasses/1/293695x100.png",
      w: 100,
      h: 100
    }]
  }, {
    name: "mobile",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/glasses/1/293695x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/glasses/1/293695x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/glasses/1/293695x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Szklanka do whisky Experience 325 ml STOLZLE",
  originalSrc: "/static/images/products/glasses/2/293695x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/glasses/2/293692x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/glasses/2/293692x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/glasses/2/293692x100.png",
      w: 100,
      h: 100
    }]
  }, {
    name: "mobile",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/glasses/2/293692x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/glasses/2/293692x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/glasses/2/293692x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Szklanka do whisky Experience 325 ml STOLZLE",
  originalSrc: "/static/images/products/glasses/3/02232x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/glasses/3/02232x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/glasses/3/02232x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/glasses/3/02232x100.png",
      w: 100,
      h: 100
    }]
  }, {
    name: "mobile",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/glasses/3/02232x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/glasses/3/02232x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/glasses/3/02232x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Szklanka do whisky Experience 325 ml STOLZLE",
  originalSrc: "/static/images/products/glasses/4/03854x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/glasses/4/03854x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/glasses/4/03854x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/glasses/4/03854x100.png",
      w: 100,
      h: 100
    }]
  }, {
    name: "mobile",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/glasses/4/03854x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/glasses/4/03854x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/glasses/4/03854x100.png",
      w: 100,
      h: 100
    }]
  }]
}];
var plates = [{
  altText: "Talerz płaski Vital Rectangle 4,3 x 8 cm ARIANE",
  originalSrc: "/static/images/products/plates/1/288389x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/plates/1/288389x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/plates/1/288389x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/plates/1/288389x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Talerz płaski La Scala 21 cm VILLEROY&BOCH",
  originalSrc: "/static/images/products/plates/2/294730x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/plates/2/294730x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/plates/2/294730x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/plates/2/294730x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Talerz prostokątny Raku Topaz Blue 26,9 x 12,7 cm CHURCHILL",
  originalSrc: "/static/images/products/plates/3/285096x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/plates/3/285096x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/plates/3/285096x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/plates/3/285096x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Talerz głęboki do burgera Vital Coupe 26 cm ARIANE",
  originalSrc: "/static/images/products/plates/4/288593x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/plates/4/288593x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/plates/4/288593x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/plates/4/288593x100.png",
      w: 100,
      h: 100
    }]
  }]
}];
var cutlery = [{
  altText: "Widelec stołowy Settecento Txt 20,1 cm PINTI INOX",
  originalSrc: "/static/images/products/cutlery/1/283734x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/cutlery/1/283734x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/cutlery/1/283734x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/cutlery/1/283734x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Nóż deserowy Settecento Txt 20,2 cm PINTI INOX",
  originalSrc: "/static/images/products/cutlery/2/283738x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/cutlery/2/283738x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/cutlery/2/283738x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/cutlery/2/283738x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Łyżeczka do kawy Settecento Txt 11,8 cm PINTI INOX",
  originalSrc: "/static/images/products/cutlery/3/283740x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/cutlery/3/283740x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/cutlery/3/283740x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/cutlery/3/283740x100.png",
      w: 100,
      h: 100
    }]
  }]
}, {
  altText: "Chochelka do sosu Durban 18 cm SOLA",
  originalSrc: "/static/images/products/cutlery/4/304596x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/cutlery/4/304596x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/cutlery/4/304596x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/cutlery/4/304596x100.png",
      w: 100,
      h: 100
    }]
  }]
}];
var pans = [{
  altText: "Patelnia Aries z powłoką Teflon™ PlatinumPlus 36 cm AMBITION",
  originalSrc: "/static/images/products/pans/1/85685x1024.png",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/products/pans/1/85685x1024.png",
      w: 1024,
      h: 1024
    }, {
      url: "/static/images/products/pans/1/85685x420.png",
      w: 420,
      h: 420
    }, {
      url: "/static/images/products/pans/1/85685x100.png",
      w: 100,
      h: 100
    }]
  }]
}];
var collage1 = {
  altText: "Collage png 1",
  originalSrc: "/static/images/collage1.png",
  variants: [{
    name: "natural",
    aspectRatio: 0.92,
    srcset: [{
      url: "/static/images/collage1.png",
      w: 590,
      h: 640
    }]
  }]
};
var collage2 = {
  altText: "Collage png 2",
  originalSrc: "/static/images/collage2.png",
  variants: [{
    name: "natural",
    aspectRatio: 1.11,
    srcset: [{
      url: "/static/images/collage2.png",
      w: 700,
      h: 630
    }]
  }]
};
var verticalSlide1 = {
  altText: "Vertical image for slider",
  originalSrc: "/static/images/slide1.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 0.7716,
    srcset: [{
      url: "/static/images/slide1.jpg",
      w: 375,
      h: 486
    }]
  }]
};
var verticalSlide2 = {
  altText: "Vertical image for slider",
  originalSrc: "/static/images/slide2.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 0.8659,
    srcset: [{
      url: "/static/images/slide2.jpg",
      w: 840,
      h: 970
    }]
  }]
};
var verticalSlide3 = {
  altText: "Vertical image for slider",
  originalSrc: "/static/images/slide3.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 0.8,
    srcset: [{
      url: "/static/images/slide3.jpg",
      w: 720,
      h: 900
    }]
  }]
};
var verticalSlide4 = {
  altText: "Vertical image for slider",
  originalSrc: "/static/images/slide4.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 0.8285,
    srcset: [{
      url: "/static/images/slide4.jpg",
      w: 580,
      h: 700
    }]
  }]
};
var verticalSlide5 = {
  altText: "Vertical image for slider",
  originalSrc: "/static/images/slide5.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 0.74,
    srcset: [{
      url: "/static/images/slide5.jpg",
      w: 566,
      h: 764
    }]
  }]
};
var basicBannerSingle = {
  altText: "Image for basic banner",
  originalSrc: "/static/images/slide5.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 2.52,
    srcset: [{
      url: "/static/images/banners/basic_single.jpg",
      w: 566,
      h: 764
    }]
  }, {
    name: "mobile",
    aspectRatio: 1.33,
    srcset: [{
      url: "/static/images/banners/basic_single_mobile.jpg",
      w: 566,
      h: 764
    }]
  }]
};
var basicBannerDouble = {
  altText: "Image for basic banner",
  originalSrc: "/static/images/banners/basic_double.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 2.52,
    srcset: [{
      url: "/static/images/banners/basic_double.jpg",
      w: 566,
      h: 764
    }]
  }, {
    name: "mobile",
    aspectRatio: 1.33,
    srcset: [{
      url: "/static/images/banners/basic_double_mobile.jpg",
      w: 566,
      h: 764
    }]
  }]
};
var newsletterBackground = {
  altText: "Newsletter",
  originalSrc: "/static/images/newsletter_bg_desktop.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 2.52,
    srcset: [{
      url: "/static/images/newsletter_bg_desktop.jpg",
      w: 566,
      h: 764
    }]
  }, {
    name: "mobile",
    aspectRatio: 1.33,
    srcset: [{
      url: "/static/images/newsletter_bg_mobile.jpg",
      w: 566,
      h: 764
    }]
  }]
};
var shopDeals1 = {
  altText: "Shop deals",
  originalSrc: "/static/images/deal1.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 0.82,
    srcset: [{
      url: "/static/images/deal1.jpg",
      w: 429,
      h: 522
    }]
  }]
};
var shopDeals2 = {
  altText: "Shop deals",
  originalSrc: "/static/images/deal2.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 0.82,
    srcset: [{
      url: "/static/images/deal2.jpg",
      w: 429,
      h: 522
    }]
  }]
};
var relatedStories1 = {
  altText: "GreenPan Nonstick Skillet",
  originalSrc: "/static/images/related1.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/related1.jpg",
      w: 375,
      h: 375
    }]
  }]
};
var relatedStories2 = {
  altText: "GreenPan Nonstick Skillet",
  originalSrc: "/static/images/related2.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/related2.jpg",
      w: 223,
      h: 223
    }]
  }]
};
var no_image = {
  originalSrc: "/static/images/no-image.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1,
    srcset: [{
      url: "/static/images/no-image.jpg",
      w: 2000,
      h: 2000
    }]
  }]
};
exports.no_image = no_image;
var loginBg = {
  originalSrc: "/static/images/logowanie-zdjecie-tlo.jpg",
  variants: [{
    name: "natural",
    aspectRatio: 1.85,
    srcset: [{
      url: "/static/images/logowanie-zdjecie-tlo.jpg",
      w: 1920,
      h: 1039
    }]
  }]
};
var images = {
  catImage: catImage,
  collectionTile1: collectionTile1,
  collectionTile2: collectionTile2,
  collectionTile3: collectionTile3,
  collectionTile4: collectionTile4,
  collectionMain: collectionMain,
  collection1: collection1,
  collection2: collection2,
  inspirationMain: inspirationMain,
  inspirationMain2: inspirationMain2,
  inspirationMain3: inspirationMain3,
  inspirationMain4: inspirationMain4,
  inspirationMain5: inspirationMain5,
  inspirationMain6: inspirationMain6,
  inspirationThumb1: inspirationThumb1,
  inspirationThumb2: inspirationThumb2,
  inspirationThumb3: inspirationThumb3,
  influancerPhoto: influancerPhoto,
  instagram1: instagram1,
  instagram2: instagram2,
  instagram3: instagram3,
  pot: pot,
  chair: chair,
  knife: knife,
  mixer: mixer,
  bannerImageVertical: bannerImageVertical,
  bannerImageSmall: bannerImageSmall,
  garnkiImage: garnkiImage,
  patelnieKwadrawtoweImage: patelnieKwadrawtoweImage,
  patelnieImage: patelnieImage,
  kuchenneImage: kuchenneImage,
  newsletterTopImage: newsletterTopImage,
  verticalPhoto: verticalPhoto,
  glasses: glasses,
  plates: plates,
  cutlery: cutlery,
  pans: pans,
  collage1: collage1,
  collage2: collage2,
  verticalSlide1: verticalSlide1,
  verticalSlide2: verticalSlide2,
  verticalSlide3: verticalSlide3,
  verticalSlide4: verticalSlide4,
  verticalSlide5: verticalSlide5,
  collectionPageMain1: collectionPageMain1,
  collectionPageMain2: collectionPageMain2,
  collectionPageMain3: collectionPageMain3,
  collectionPageMain4: collectionPageMain4,
  collectionPageMain5: collectionPageMain5,
  collectionPageMain6: collectionPageMain6,
  collectionPageThumb1a: collectionPageThumb1a,
  collectionPageThumb1b: collectionPageThumb1b,
  collectionPageThumb2a: collectionPageThumb2a,
  collectionPageThumb2b: collectionPageThumb2b,
  collectionPageThumb3a: collectionPageThumb3a,
  collectionPageThumb3b: collectionPageThumb3b,
  collectionPageThumb4a: collectionPageThumb4a,
  collectionPageThumb4b: collectionPageThumb4b,
  collectionPageThumb5a: collectionPageThumb5a,
  collectionPageThumb5b: collectionPageThumb5b,
  basicBannerSingle: basicBannerSingle,
  basicBannerDouble: basicBannerDouble,
  no_image: no_image,
  newsletterBackground: newsletterBackground,
  shopDeals1: shopDeals1,
  shopDeals2: shopDeals2,
  relatedStories1: relatedStories1,
  relatedStories2: relatedStories2,
  loginBg: loginBg
};
var _default = images;
exports["default"] = _default;